import React from 'react';
import Button from './common/Button';
import useIsMobile from '../hooks/useIsMobile';
import Revoke from '../assets/Revoke.svg';

const ActionButtons = ({
	onRevoke,
	onResume,
	onExit,
	selectedAccounts,
	isDisable,
	customDetails,
}) => {
	const isMobile = useIsMobile();
	const hasActiveConsent = selectedAccounts?.some(
		(account) => account.status === 'ACTIVE'
	);

	return (
		<div
			className="accept-row mb-5"
			role="region"
			aria-label="Consent actions"
			style={{
				width: '100%',
				margin: '0 auto',
				marginLeft: isMobile ? '4px' : '0',
				borderTop: '1px solid #E0E0E0',
				paddingTop: '14px',
			}}
		>
			<div
				className="mb-2 ml-0"
				style={{
					display: 'flex',
					flexDirection: isMobile ? 'column' : 'row',
					gap: '10px',
					width: isMobile ? '76%' : '32%',
					margin: '0 auto',
				}}
			>
				<Button
					onClick={onRevoke}
					disabled={!selectedAccounts?.length || isDisable}
					aria-busy={isDisable}
					aria-label={isDisable ? 'Revoking selected consents' : 'Revoke selected consents'}
					style={{
						height: customDetails?.btnHeight,
						width: isMobile ? '100%' : '58%',
						borderRadius: customDetails?.borderRadius,
						fontFamily: customDetails?.fontFamily,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '8px',
						order: isMobile ? 1 : 2,
						whiteSpace: 'nowrap',
						fontSize: '13px',
					}}
				>
					{isDisable ? (
						<div
							className="snippet"
							style={{ display: 'flex', justifyContent: 'center' }}
							data-title=".dot-pulse"
							aria-hidden="true"
						>
							<div className="stage">
								<div className="dot-pulse-btn"></div>
							</div>
						</div>
					) : (
						<>
							<img src={Revoke} alt="" aria-hidden="true" style={{ width: '20px', height: '20px' }} />
							Revoke selected consents
						</>
					)}
				</Button>
				<Button
					onClick={onResume}
					disabled={!selectedAccounts?.length || isDisable || hasActiveConsent}
					aria-busy={isDisable}
					aria-label={
						hasActiveConsent
							? 'Resume consents unavailable for active consents'
							: isDisable
								? 'Resuming consents'
								: 'Resume consents'
					}
					variant="outlined"
					borderColor={customDetails?.btnBorderColor}
					style={{
						height: customDetails?.btnHeight,
						width: isMobile ? '100%' : '42%',
						borderRadius: customDetails?.borderRadius,
						fontFamily: customDetails?.fontFamily,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '8px',
						order: isMobile ? 2 : 1,
						whiteSpace: 'nowrap',
						fontSize: '13px',
					}}
				>
					{isDisable ? (
						<div
							className="snippet"
							style={{ display: 'flex', justifyContent: 'center' }}
							data-title=".dot-pulse"
							aria-hidden="true"
						>
							<div className="stage">
								<div className="dot-pulse-btn"></div>
							</div>
						</div>
					) : (
						<>
							<svg width="16" height="16" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
								<path d="M0.953438 5.08125C0.752438 5.22925 0.543312 5.24725 0.326063 5.13525C0.108687 5.02325 0 4.84325 0 4.59525V1.32975C0 1.08175 0.108687 0.90175 0.326063 0.78975C0.543312 0.67775 0.752438 0.69575 0.953438 0.84375L3.28706 2.4765C3.45531 2.60013 3.53944 2.76225 3.53944 2.96288C3.53944 3.16363 3.45531 3.3255 3.28706 3.4485L0.953438 5.08125ZM5.99288 5.78194C5.89762 5.68669 5.85 5.57188 5.85 5.4375V0.4875C5.85 0.353125 5.89769 0.238313 5.99306 0.143063C6.08844 0.0476876 6.20331 0 6.33769 0C6.47219 0 6.587 0.0476876 6.68213 0.143063C6.77737 0.238313 6.825 0.353125 6.825 0.4875V5.4375C6.825 5.57188 6.77731 5.68669 6.68194 5.78194C6.58656 5.87731 6.47169 5.925 6.33731 5.925C6.20281 5.925 6.088 5.87731 5.99288 5.78194ZM8.69287 5.78194C8.59762 5.68669 8.55 5.57188 8.55 5.4375V0.4875C8.55 0.353125 8.59769 0.238313 8.69306 0.143063C8.78844 0.0476876 8.90331 0 9.03769 0C9.17219 0 9.287 0.0476876 9.38212 0.143063C9.47738 0.238313 9.525 0.353125 9.525 0.4875V5.4375C9.525 5.57188 9.47731 5.68669 9.38194 5.78194C9.28656 5.87731 9.17169 5.925 9.03731 5.925C8.90281 5.925 8.788 5.87731 8.69287 5.78194Z" fill="currentColor"/>
							</svg>
							Resume consents
						</>
					)}
				</Button>
			</div>
		</div>
	);
};

export default ActionButtons;
